<template>
  <div>
    <v-tooltip
      color="primary"
      v-for="(step, i) in steps"
      :key="i"
      :activator="step.target"
      max-width="100vw"
      v-model="step.active"
      :bottom="!step.position || step.position === 'bottom'"
      :left="step.position === 'left'"
      :right="step.position === 'right'"
      :top="step.position === 'top'"
      :nudge-bottom="step.nudgeBottom ? step.nudgeBottom : 0"
      :nudge-left="step.nudgeLeft ? step.nudgeLeft : 0"
      :nudge-right="step.nudgeRight ? step.nudgeRight : 0"
      :nudge-top="step.nudgeTop ? step.nudgeTop : 0"
    >
      <v-card
        width="500px"
        elevation-20
        color="primary"
        dark
        class="tour-tooltip pa-0 ma-0 text-xs-left"
      >
        <v-card-title class="py-2" primary-title dark>
          <v-layout align-center justify-space-between row>
            <v-flex>
              <h3>{{ step.title }}</h3>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn v-if="step.showFinishButton" flat icon @click="discardHelp()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn v-else flat icon @click="goToLastStep()"><v-icon>mdi-close</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2" v-html="step.content"></v-card-text>
        <v-card-actions>
          <v-btn v-if="!step.hidePrevButton" flat @click="prevHelpStep(i)">{{ $t('Atrás') }}</v-btn>

          <v-spacer></v-spacer>
          <v-btn v-if="!step.hideNextButton" flat @click="nextHelpStep(i)">
            {{ $t('Siguiente') }}
          </v-btn>
          <v-btn v-if="step.showFinishButton" flat @click="discardHelp(i)">
            {{ $t('Entendido') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-tooltip>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruRouteGuardMixin from '@/mixins/route-guards/AruRouteGuardMixin.js';

export default {
  mixins: [AruRouteGuardMixin],

  name: 'og-help-tour',
  data() {
    return {
      steps: [
        {
          target: '#my-account-menu',
          title: 'Visita guiada al Canal Rebelde',
          content:
            'Este es el punto de acceso a los datos de tu cuenta. Desde aquí podrás visualizar los detalles de tu negocio, tu perfil como usuario y cerrar la sesión.',
          active: false,
          hidePrevButton: true,
          position: 'left',
          allowedRoles: ['pyme', 'autonomous', 'consultant', 'admin', 'superadmin'],
        },
        {
          target: '#my-account-menu',
          title: 'Visita guiada a OpenData',
          content:
            'Este es el punto de acceso a los datos de tu cuenta. Desde aquí podrás visualizar tu perfil como usuario y cerrar la sesión.',
          active: false,
          hidePrevButton: true,
          position: 'left',
          onlyHasRole: 'lopd',
        },
        {
          target: '#dashboard-economic', // We're using document.querySelector() under the hood
          title: 'Mi negocio',
          content:
            'Con acceso a los indicadores clave de tu negocio en tiempo real para que puedas tomar las mejores decisiones. Controla tus ingresos, gastos, y beneficios y compáralos con periodos anteriores para analizar su evolución.',
          active: false,
          allowedRoles: ['pyme', 'autonomous', 'consultant', 'admin', 'superadmin'],
        },
        {
          target: '#myconsultant-toolbar', // We're using document.querySelector() under the hood
          title: 'Mi asesor',
          content:
            'Área de conversaciones desde la que podrás formular cualquier consulta sobre tu negocio siempre que quieras, o enviarle un documento en el momento en que mejor te convenga.',
          active: false,
          allowedRoles: ['all'],
        },
        {
          target: '#openbox-toolbar',
          title: 'OpenBox',
          content:
            '<p>Un intuitivo panel diseñado para que puedas descargar los documentos clave de tu negocio siempre que los necesites. Sin necesidad de pedírselos a tu asesor y esperar a que te los mande. Los últimos balances de tu negocio, las declaraciones fiscales presentadas, las nóminas mensuales de tus empleados, y mucho más. </p><p> Además, desde OpenBox podrás enviar las facturas y otros documentos a contabilizar a tu asesor de una forma rápida y sencilla.</p>',
          active: false,
          allowedRoles: ['pyme', 'autonomous', 'consultant', 'admin', 'superadmin'],
        },
        {
          target: '#opendata-toolbar',
          title: 'Opendata',
          content:
            '<p>OpenData es la aplicación web que te ayudará a adaptarte al Reglamento Europeo de Protección de Datos, así como a la Ley Orgánica de Protección de Datos y de Garantía de los Derechos Digitales. Completa un breve cuestionario y genera los documentos personalizados de tu negocio (avisos legales, contratos de confidencialidad para empleados, etc). Con unas sencillas instrucciones que te guiarán para que la implantación sea todo un éxito, y siempre acompañado por un asesor especialista.</p>',
          active: false,
          allowedRoles: ['lopd', 'consultant', 'admin', 'superadmin'],
        },
        {
          target: '#help-center-image',
          title: 'Centro de ayuda',
          content:
            'El lugar desde el que poder repetir esta visita guiada y acceder a tutoriales sobre cómo utilizar el servicio OpenData, así como respuestas a preguntas frecuentes.',
          active: false,
          hideNextButton: true,
          showFinishButton: true,
          position: 'right',
          allowedRoles: ['lopd'],
        },
        {
          target: '#help-center-image',
          title: 'Centro de ayuda',
          content:
            'El lugar desde el que poder repetir esta visita guiada y acceder a tutoriales sobre cómo utilizar el Canal Rebelde, así como respuestas a preguntas frecuentes.',
          active: false,
          hideNextButton: true,
          showFinishButton: true,
          position: 'right',
          allowedRoles: ['pyme', 'autonomous', 'consultant', 'admin', 'superadmin'],
        },
      ],
      currentStep: {},
    };
  },
  mounted: function() {
    this.clearPulse();
    if (!this.$store.state.user.skip_tour) {
      this.startTour();
    }
  },
  methods: {
    startTour() {
      this.goToStep(this.getNextStep(-1));
      console.log('Starting visit');
    },
    goToStep(i) {
      if (typeof this.steps[i] !== 'undefined') {
        this.steps[i].active = true;
        this.addPulseToTarget(this.steps[i].target);
      }
    },

    addPulseToTarget(target) {
      let element = document.querySelector(target);
      if (element) {
        element.insertAdjacentHTML(
          'afterbegin',
          `
              <div class="circle secondary" style="animation-delay: -1.5s"></div>
              <div class="circle secondary" style="animation-delay: -1s"></div>
              <div class="circle secondary" style="animation-delay: -0.5s"></div>
              <div class="circle primary" style="animation-delay: 0s"></div>`,
        );
      }
    },
    clearPulse() {
      let pulseElement = document.querySelectorAll('.circle');
      if (pulseElement.length > 0) {
        pulseElement.forEach(element => {
          element.parentNode.removeChild(element);
        });
      }
    },
    closeStep(i) {
      this.clearPulse();
      if (typeof this.steps[i] !== 'undefined') {
        this.steps[i].active = false;
      }
    },
    goToLastStep() {
      this.clearPulse();

      for (let i = 0; i < this.steps.length; i++) {
        this.steps[i].active = false;
      }
      this.goToStep(this.steps.length - 1);
    },
    discardHelp() {
      this.clearPulse();

      for (let i = 0; i < this.steps.length; i++) {
        this.steps[i].active = false;
      }

      apiCtrl.post('/user/skip-tour').then(res => {
        console.log(res);
        this.$store.dispatch('skipTour');
      });
    },
    nextHelpStep(i) {
      this.closeStep(i);
      const nextStep = this.getNextStep(i);
      this.goToStep(nextStep);
    },

    getNextStep(i) {
      for (let index = i + 1; index < this.steps.length; index++) {
        const element = this.steps[index];
        if (!element) {
          return this.steps.length - 1;
        }

        if (element.hasOwnProperty('onlyHasRole')) {
          if (this.userOnlyHasRole(element.onlyHasRole)) {
            return index;
          }
        } else if (this.userHasAnyRole(element.allowedRoles)) {
          return index;
        }
      }
      return this.steps.length - 1;
    },

    getPrevStep(i) {
      // eslint-disable-next-line for-direction
      for (let index = i - 1; index < this.steps.length; index--) {
        const element = this.steps[index];
        if (!element) {
          return 0;
        }

        if (element.hasOwnProperty('onlyHasRole')) {
          if (this.userOnlyHasRole(element.onlyHasRole)) {
            return index;
          }
        } else if (this.userHasAnyRole(element.allowedRoles)) {
          return index;
        }
      }
      return 0;
    },

    prevHelpStep(i) {
      this.closeStep(i);
      const prevStep = this.getPrevStep(i);

      this.goToStep(prevStep);
    },
  },
};
</script>

<style>
@keyframes scaleIn {
  from {
    transform: scale(0.1, 0.1);
    opacity: 0.5;
  }
  to {
    transform: scale(3.5, 3.5);
    opacity: 0;
  }
}

.circle {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  position: absolute;
  opacity: 0;
  animation: scaleIn 2s infinite cubic-bezier(0.36, 0.11, 0.89, 0.32);
}

.pulse {
  display: block;
  width: 1px;
  height: 1px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 0 rgba(0, 175, 168, 0.6);
  animation: pulse 2s infinite;
  position: absolute;
}
.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 175, 168, 0.6);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 175, 168, 0.6);
    box-shadow: 0 0 0 0 rgba(0, 175, 168, 0.6);
  }
  70% {
    -moz-box-shadow: 0 0 0 60px rgba(0, 175, 168, 0);
    box-shadow: 0 0 0 60px rgba(0, 175, 168, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 175, 168, 0);
    box-shadow: 0 0 0 0 rgba(0, 175, 168, 0);
  }
}
</style>

<style scoped>
.v-tooltip__content {
  padding: 0px;
  opacity: 0.95 !important;
}
</style>
